export const FormatDateAndTime = 'DD/MM/YYYY h:MM A';
export const FormatDate = 'DD/MM/YYYY';
